import React , {useState} from "react";
import { endPoints } from "../../../config";
import { axiosInstnace } from "../../../util/util";

export const CommonModelImpl = ({
  headerMsg,
  msg,
  okButtonShow,
  okButtonText,
  okAction,
  cancelButtonShow,
  cancelButtonText,
  cancelAction,
  tps,
  stationList,
  currentAdmin
}) => {
  const [userlist, setmentorlist] = useState([]);
  const [station, setstation] = useState("");
  const [user, setuser] = useState("");

  const getusers = async (city) => {
    let users = await axiosInstnace.get(endPoints.getusersofcity, {
      params: {
        city: city,
        role: ["salesUser", "stationAdmin"],
      },
    });
    users = users.data.data.filter((e)=>{
      return e._id !== currentAdmin._id
    })
    setmentorlist(users);
  };

  const handleSubmit = ()=>{
    if(user){
      okAction(user)
    }else{
      okAction()
    }
  }

  //Return common model for performing dynamic action
  return (
    <div className="modal-overlay">
      <div
        className="modal-wrapper thankyou-popup"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal approval">
          <div className="modal-head-cross rate-modal">
            <button
              type="button"
              className="modal-close-button"
              onClick={cancelAction}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="editNonFct-header modal-header">
              <h4 className="popup-head rqst-head fct-head modal-title">
                {headerMsg}
              </h4>
            </div>
            <div className="approval-content modal-body">
              <div className="popup-container reqst-rejection">
                <p className="reqst-para approval-reqst">{msg}</p>
                {tps > 0 && (
                  <div>
                    {" "}
                    <div class="gstdetail" style={{marginBottom:"20px"}}>
                      <span class="detailinner_header"> Base Station </span>
                      <span>
                        {" "}
                        <select
                          class="packageType drop-down-icon"
                          name="state"
                          value={station}
                          onChange={(e) => {
                            getusers(e.target.value);
                            setstation(e.target.value);
                          }}
                        >
                          <option value="">Select base station</option>
                          {stationList.map((state) => {
                            return <option value={state}>{state}</option>;
                          })}
                        </select>
                      </span>
                    </div>
                    <div class="gstdetail" style={{marginBottom:"20px"}}>
                      <span class="detailinner_header"> Mentor Id </span>
                      <select
                        class="packageType drop-down-icon"
                        name="state"
                        value={user}
                        onChange={(e) => {
                          setuser(e.target.value);
                        }}
                      >
                        <option value="">Select your mentor</option>
                        {userlist &&
                          userlist.map((state) => {
                            return (
                              <option
                                value={state.email}
                              >{`${state.name} (${state.email})`}</option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                )}
                <div className="confirn-btn">
                  {cancelButtonShow && (
                    <button className="cancel-reqst" onClick={cancelAction}>
                      {cancelButtonText}
                    </button>
                  )}
                  {okButtonShow && (
                    <button className="confirm-reqst" onClick={handleSubmit}>
                      {okButtonText}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web/components/admin/common/CommonModel.jsx